import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiResponse } from './api.service';

@Injectable()
export class ParameterService {

  private API_URL = environment.apiUrl;
  private PARAM_URL = environment.parameterApiUrl;
  public BTM_URL: string = environment.btmApiUrl;


  constructor(private http: HttpClient) {

  }

  getHotelCitiesForDropdown(query) {
    let param = query ? ('?'+query ): '';
    return this.http.get<ApiResponse>(this.PARAM_URL + `/parameters/hotel/cities${param}`);
  }

  getCities(query?) {
    let param = query ? ('?'+query ): '';
    return this.http.get<ApiResponse>(this.PARAM_URL + `/parameters/hotel/cities${param}`);
  }

  autoSuggest(param) {
    return this.http.get<ApiResponse>(`https://places.api.here.com/places/v1/autosuggest?at=0,0&q=${param.q}&size=10&Accept-Language=tr-TR,tr;q=0.9,en-US;q=0.8,en;q=0.7&app_id=${'DvkMLJUCGTNvYUfJKvjI'}&app_code=WCu2vYFedd98VySNf6gWWQ`)
  }

  reverseSuggest(param) {
    const header = new HttpHeaders().set("Accept-Language", 'en-En,en;q=0.9');
    return this.http.get<ApiResponse>(param, { headers: header })
  }

  getHotelCities(param) {
    return this.http.post<ApiResponse>(this.PARAM_URL + `/parameters/hotel/cities/validate`, param);
  }

  getHotels(param) {
    return this.http.get<ApiResponse>(`${this.BTM_URL}/btm/hotels/searchHotelsWithMatch?${param}`);

  }

  getCountries(param) {
    return this.http.get<ApiResponse>(this.PARAM_URL + `/parameters/country${param ? ('?' + param.toString()) : ''}`);
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/utils/services/parameter.service.ts